import { __spreadArray } from 'tslib';
import { parse } from 'content-type';

var svgNamespace$1 = 'http://www.w3.org/2000/svg';
var extractSymbol = function (spriteSvg, symbolId) {
  var symbol = spriteSvg.querySelector('#' + CSS.escape(symbolId));
  if ((symbol === null || symbol === void 0 ? void 0 : symbol.tagName.toLowerCase()) !== 'symbol') {
    return null;
  }
  var svg = document.createElementNS(svgNamespace$1, 'svg');
  var attrs = symbol.attributes;
  for (var i = 0, len = attrs.length; i < len; i++) {
    var attr = attrs[i];
    if (attr.name !== 'id') {
      svg.setAttribute(attr.name, attr.value);
    }
  }
  var children = symbol.childNodes;
  for (var i = 0, len = children.length; i < len; i++) {
    svg.appendChild(children[i].cloneNode(true));
  }
  return svg;
};

var cache = new Map();

var cloneSvg = function (sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function () {
  return window.location.protocol === 'file:';
};

var makeAjaxRequest = function (url, httpRequestWithCredentials, callback) {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
        var contentType = httpRequest.getResponseHeader('Content-Type');
        if (!contentType) {
          throw new Error('Content type not found');
        }
        var type = parse(contentType).type;
        if (!(type === 'image/svg+xml' || type === 'text/plain')) {
          throw new Error("Invalid content type: ".concat(type));
        }
      }
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without ' + 'adjusting security settings in your browser. Or consider ' + 'using a local webserver.' : 'Unable to load SVG file: ' + url);
        }
        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          callback(null, httpRequest);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      httpRequest.abort();
      if (error instanceof Error) {
        callback(error, httpRequest);
      } else {
        throw error;
      }
    }
  };
  httpRequest.open('GET', url);
  httpRequest.withCredentials = httpRequestWithCredentials;
  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('image/svg+xml');
  }
  httpRequest.send();
};

var requestQueue = {};
var queueRequest = function (url, callback) {
  var _a;
  (_a = requestQueue[url]) !== null && _a !== void 0 ? _a : requestQueue[url] = [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function (url) {
  var callbacks = requestQueue[url];
  if (!callbacks) {
    return;
  }
  var _loop_1 = function (i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = cache.get(url);
        var callback = callbacks[i];
        if (!callback) {
          return;
        }
        if (cacheValue instanceof SVGSVGElement) {
          callback(null, cloneSvg(cacheValue));
        }
        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }
        if (i === callbacks.length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };
  for (var i = 0, len = callbacks.length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvgCached = function (url, httpRequestWithCredentials, callback) {
  if (cache.has(url)) {
    var cacheValue = cache.get(url);
    if (cacheValue === undefined) {
      queueRequest(url, callback);
      return;
    }
    if (cacheValue instanceof SVGSVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }
  }
  cache.set(url, undefined);
  queueRequest(url, callback);
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      cache.set(url, error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      cache.set(url, httpRequest.responseXML.documentElement);
    }
    processRequestQueue(url);
  });
};

var loadSvgUncached = function (url, httpRequestWithCredentials, callback) {
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      callback(error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      callback(null, httpRequest.responseXML.documentElement);
    }
  });
};

var dataUrlPrefix = 'data:image/svg+xml';
var parseDataUrl = function (url) {
  if (!url.startsWith(dataUrlPrefix)) {
    return null;
  }
  var rest = url.slice(dataUrlPrefix.length);
  var svgString;
  if (rest.startsWith(';base64,')) {
    try {
      svgString = atob(rest.slice(';base64,'.length));
    } catch (_a) {
      return new Error('Invalid base64 in data URL');
    }
  } else if (rest.startsWith(',')) {
    try {
      svgString = decodeURIComponent(rest.slice(','.length));
    } catch (_b) {
      return new Error('Invalid encoding in data URL');
    }
  } else if (rest.startsWith(';charset=utf-8,')) {
    try {
      svgString = decodeURIComponent(rest.slice(';charset=utf-8,'.length));
    } catch (_c) {
      return new Error('Invalid encoding in data URL');
    }
  } else {
    return new Error('Unsupported data URL format');
  }
  var doc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
  var parserError = doc.querySelector('parsererror');
  if (parserError) {
    return new Error('Data URL SVG parse error: ' + parserError.textContent.trim());
  }
  if (!(doc.documentElement instanceof SVGSVGElement)) {
    return new Error('Data URL did not contain a valid SVG element');
  }
  return doc.documentElement;
};

var idCounter = 0;
var uniqueId = function () {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var injectElement = function (el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
  var _a;
  var elUrl = (_a = el.getAttribute('data-src')) !== null && _a !== void 0 ? _a : el.getAttribute('src');
  if (!elUrl) {
    callback(new Error('Invalid data-src or src attribute'));
    return;
  }
  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }
  injectedElements.push(el);
  el.setAttribute('src', '');
  var hashIndex = elUrl.indexOf('#');
  var baseUrl = hashIndex !== -1 ? elUrl.slice(0, hashIndex) : elUrl;
  var symbolId = hashIndex !== -1 ? elUrl.slice(hashIndex + 1) : null;
  var dataUrlResult = parseDataUrl(baseUrl);
  if (dataUrlResult instanceof Error) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(dataUrlResult);
    return;
  }
  var handleLoadedSvg = function (error, loadedSvg) {
    var _a, _b;
    if (!loadedSvg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }
    var svg = loadedSvg;
    if (symbolId) {
      var symbolSvg = extractSymbol(loadedSvg, symbolId);
      if (!symbolSvg) {
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        callback(new Error("Symbol \"".concat(symbolId, "\" not found in ").concat(baseUrl)));
        return;
      }
      svg = symbolSvg;
    }
    var elId = el.getAttribute('id');
    if (elId) {
      svg.setAttribute('id', elId);
    }
    var elTitle = el.getAttribute('title');
    if (elTitle) {
      svg.setAttribute('title', elTitle);
    }
    var elWidth = el.getAttribute('width');
    if (elWidth) {
      svg.setAttribute('width', elWidth);
    }
    var elHeight = el.getAttribute('height');
    if (elHeight) {
      svg.setAttribute('height', elHeight);
    }
    var mergedClasses = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], ((_a = svg.getAttribute('class')) !== null && _a !== void 0 ? _a : '').split(' '), true), ['injected-svg'], false), ((_b = el.getAttribute('class')) !== null && _b !== void 0 ? _b : '').split(' '), true))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var elStyle = el.getAttribute('style');
    if (elStyle) {
      svg.setAttribute('style', elStyle);
    }
    svg.setAttribute('data-src', elUrl);
    var elData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(elData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });
    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var replaceIriReferences_1 = function (value, iriIdMap) {
        return value.replace(/url\((['"]?)\s*#([^\s'"\)]+)\s*\1\)/g, function (match, _quote, iriId) {
          var newId = iriIdMap[iriId];
          return newId ? "url(#".concat(newId, ")") : match;
        });
      };
      var replaceHrefReference = function (value, iriIdMap) {
        if (!value.startsWith('#')) {
          return value;
        }
        var iriId = value.slice(1);
        var newId = iriIdMap[iriId];
        return newId ? '#' + newId : value;
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      var renumeratedElements_1 = [];
      var iriIdMap_1 = {};
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        elements_1 = svg.querySelectorAll(element_1 + '[id]');
        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          var currentElement = elements_1[a];
          currentId_1 = currentElement.id;
          newId_1 = currentId_1 + '-' + uniqueId();
          iriIdMap_1[currentId_1] = newId_1;
          renumeratedElements_1.push({
            element: currentElement,
            currentId: currentId_1,
            newId: newId_1
          });
        }
      });
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        properties_1 = iriElementsAndProperties_1[key];
        var referencingElements;
        Array.prototype.forEach.call(properties_1, function (property) {
          referencingElements = svg.querySelectorAll('[' + property + ']');
          for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
            var referencingElement = referencingElements[b];
            var attrValue = referencingElement.getAttribute(property);
            if (attrValue) {
              var nextValue = replaceIriReferences_1(attrValue, iriIdMap_1);
              if (nextValue !== attrValue) {
                referencingElement.setAttribute(property, nextValue);
              }
            }
          }
        });
      });
      var allLinks = svg.querySelectorAll('*');
      for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
        var link = allLinks[c];
        var href = link.getAttribute('href');
        if (href) {
          var nextHref = replaceHrefReference(href, iriIdMap_1);
          if (nextHref !== href) {
            link.setAttribute('href', nextHref);
          }
        }
        var xlinkHref = link.getAttributeNS(xlinkNamespace, 'href');
        if (xlinkHref) {
          var nextXlinkHref = replaceHrefReference(xlinkHref, iriIdMap_1);
          if (nextXlinkHref !== xlinkHref) {
            link.setAttributeNS(xlinkNamespace, 'href', nextXlinkHref);
          }
        }
      }
      var styleElements = svg.querySelectorAll('[style]');
      for (var d = 0, styleElementsLen = styleElements.length; d < styleElementsLen; d++) {
        var styleElement = styleElements[d];
        var styleValue = styleElement.getAttribute('style');
        if (styleValue) {
          var nextStyleValue = replaceIriReferences_1(styleValue, iriIdMap_1);
          if (nextStyleValue !== styleValue) {
            styleElement.setAttribute('style', nextStyleValue);
          }
        }
      }
      var styleTagElements = svg.querySelectorAll('style');
      for (var e = 0, styleTagElementsLen = styleTagElements.length; e < styleTagElementsLen; e++) {
        var styleTagElement = styleTagElements[e];
        var textContent = styleTagElement.textContent;
        if (textContent) {
          var nextTextContent = replaceIriReferences_1(textContent, iriIdMap_1);
          if (nextTextContent !== textContent) {
            styleTagElement.textContent = nextTextContent;
          }
        }
      }
      for (var f = 0, renumeratedElementsLen = renumeratedElements_1.length; f < renumeratedElementsLen; f++) {
        renumeratedElements_1[f].element.id = renumeratedElements_1[f].newId;
      }
    }
    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;
    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      var scriptElement = scripts[i];
      scriptType = scriptElement.getAttribute('type');
      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scriptElement.innerText || scriptElement.textContent;
        if (script) {
          scriptsToEval.push(script);
        }
        svg.removeChild(scriptElement);
      }
    }
    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[elUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }
      ranScripts[elUrl] = true;
    }
    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace);
    svg.setAttribute('xmlns:xlink', xlinkNamespace);
    beforeEach(svg);
    if (!el.parentNode) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(new Error('Parent node is null'));
      return;
    }
    el.parentNode.replaceChild(svg, el);
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  };
  if (dataUrlResult) {
    setTimeout(function () {
      handleLoadedSvg(null, dataUrlResult);
    }, 0);
    return;
  }
  var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
  loadSvg(baseUrl, httpRequestWithCredentials, handleLoadedSvg);
};

var SVGInjector = function (elements, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.afterAll,
    afterAll = _c === void 0 ? function () {
      return undefined;
    } : _c,
    _d = _b.afterEach,
    afterEach = _d === void 0 ? function () {
      return undefined;
    } : _d,
    _e = _b.beforeEach,
    beforeEach = _e === void 0 ? function () {
      return undefined;
    } : _e,
    _f = _b.cacheRequests,
    cacheRequests = _f === void 0 ? true : _f,
    _g = _b.evalScripts,
    evalScripts = _g === void 0 ? 'never' : _g,
    _h = _b.httpRequestWithCredentials,
    httpRequestWithCredentials = _h === void 0 ? false : _h,
    _j = _b.renumerateIRIElements,
    renumerateIRIElements = _j === void 0 ? true : _j;
  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;
    for (var i = 0, j = elements.length; i < j; i++) {
      var element = elements[i];
      if (!element) {
        continue;
      }
      injectElement(element, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
        afterEach(error, svg);
        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};

export { SVGInjector };
//# sourceMappingURL=svg-injector.esm.js.map
